if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId || 'announcement';
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = Array.from(this.querySelectorAll('.js-announcement-link'));
      this.menu = document.querySelector('.main-menu__content');
      this.isPaused = false;
      this.sliderTimer = null;
      this.breakpointHandler = this.handleBreakpointChange.bind(this);

      window.addEventListener('on:breakpoint-change', this.breakpointHandler);

      if (this.slider) {
        this.slider.addEventListener('mouseenter', () => {
          this.isPaused = true;
        });
        this.slider.addEventListener('mouseleave', () => {
          this.isPaused = false;
        });
      }

      this.moveLinks();
      this.moveLocalization();
      this.initSlider();
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.breakpointHandler);
      if (this.sliderTimer) clearTimeout(this.sliderTimer);
    }

    isDesktop() {
      return window.matchMedia('(min-width: 769px)').matches;
    }

    handleBreakpointChange() {
      this.menu = document.querySelector('.main-menu__content');
      this.moveLinks();
      this.moveLocalization();
    }

    moveLinks() {
      if (!this.menu || this.links.length === 0) return;

      const selector = `.mob__announcement-links[data-announcement-id="${this.sectionId}"]`;
      const existing = document.querySelector(selector);

      if (!this.isDesktop() && !existing) {
        const nav = document.createElement('nav');
        nav.className = 'mob__announcement-links';
        nav.dataset.announcementId = this.sectionId;

        const list = document.createElement('ul');
        list.className = 'secondary-nav';

        this.links.forEach((link) => {
          const item = document.createElement('li');
          const anchor = document.createElement('a');
          anchor.className = 'secondary-nav__item';
          anchor.href = link.href;
          anchor.textContent = link.textContent.trim();
          item.appendChild(anchor);
          list.appendChild(item);
        });

        nav.appendChild(list);
        this.menu.appendChild(nav);
      } else if (this.isDesktop() && existing) {
        existing.remove();
      }
    }

    moveLocalization() {
      if (!this.menu || !this.localization) return;

      const selector = `.mob__localization[data-announcement-id="${this.sectionId}"]`;
      const existing = document.querySelector(selector);

      if (!this.isDesktop() && !existing && this.localization.firstElementChild) {
        const mobileLocalization = document.createElement('div');
        mobileLocalization.className = 'mob__localization';
        mobileLocalization.dataset.announcementId = this.sectionId;
        mobileLocalization.appendChild(this.localization.firstElementChild);
        this.menu.appendChild(mobileLocalization);
      } else if (this.isDesktop() && existing && existing.firstElementChild) {
        this.localization.appendChild(existing.firstElementChild);
        existing.remove();
      }
    }

    initSlider() {
      if (!this.slider) return;

      const slides = Array.from(this.slider.querySelectorAll('.announcement__text'));
      if (slides.length < 2) return;

      slides[0].classList.add('is-visible');
      const delay = Number(this.dataset.slideDelay) || 7000;

      const advance = () => {
        if (!this.isPaused && !document.hidden) {
          const current = this.slider.querySelector('.announcement__text.is-visible') || slides[0];
          const currentIndex = slides.indexOf(current);
          const nextIndex = currentIndex + 1 < slides.length ? currentIndex + 1 : 0;
          const next = slides[nextIndex];

          this.slider.scrollTo({
            left: document.dir === 'rtl' ? -Math.abs(next.offsetLeft) : next.offsetLeft,
            behavior: 'smooth'
          });

          current.classList.remove('is-visible');
          next.classList.add('is-visible');
        }

        this.sliderTimer = window.setTimeout(advance, delay);
      };

      this.sliderTimer = window.setTimeout(advance, delay);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
